import { z } from "zod";

export const AlignmentItemSchema = z.object({
  line: z.number(),
  word: z.number(),
  subword: z.number(),
  start: z.number(),
  end: z.number(),
  text: z.string(),
  singer: z.number().optional(),
});

export const AlignmentSchema = z.object({
  items: z.array(AlignmentItemSchema),
});

export const LanguageSchema = z.enum([
  "af",
  "ar",
  "hy",
  "az",
  "be",
  "bs",
  "bg",
  "ca",
  "zh",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "et",
  "tl",
  "fi",
  "fr",
  "gl",
  "de",
  "el",
  "he",
  "hi",
  "hu",
  "is",
  "id",
  "it",
  "ja",
  "kn",
  "kk",
  "ko",
  "lv",
  "lt",
  "mk",
  "mi",
  "ms",
  "mr",
  "ne",
  "no",
  "fa",
  "pl",
  "pt",
  "ro",
  "ru",
  "sr",
  "sk",
  "sl",
  "es",
  "sw",
  "sv",
  "ta",
  "th",
  "tr",
  "uk",
  "ur",
  "vi",
  "cy",
]);
export type Language = z.infer<typeof LanguageSchema>;

export const GoogleApplicationCredentialsSchema = z.object({
  type: z.string(),
  project_id: z.string(),
  private_key_id: z.string(),
  private_key: z.string(),
  client_email: z.string(),
  client_id: z.string(),
  auth_uri: z.string(),
  token_uri: z.string(),
  auth_provider_x509_cert_url: z.string(),
  client_x509_cert_url: z.string(),
  universe_domain: z.string(),
});

export type GoogleApplicationCredentials = z.infer<
  typeof GoogleApplicationCredentialsSchema
>;

export const FileExtensionSchema = z.enum(["mp3", "m4a", "mp4", "aac"]);

export type FileExtension = z.infer<typeof FileExtensionSchema>;

export const PaginationSchema = z.object({
  page: z.number().min(1),
  pageSize: z.number().min(1).max(100),
});

export type Pagination = z.infer<typeof PaginationSchema>;

export interface IStyleOptions {
  alignment: number;
  angle: number;
  backColour: string;
  bold: boolean;
  borderStyle: number;
  encoding: number;
  fontname: string;
  fontsize: number;
  italic: boolean;
  marginL: number;
  marginR: number;
  marginV: number;
  name: string;
  outline: number;
  outlineColour: string;
  activeOutlineColor: string;
  primaryColour: string;
  scaleX: number;
  scaleY: number;
  secondaryColour: string;
  shadow: number;
  spacing: number;
  strikeOut: 0 | 1;
  underline: boolean;
  uppercase: boolean;
  activeColour: string;
  blur?: number;
  alpha?: number;
}

export const StyleOptionsSchema = z.object({
  alignment: z.number(),
  angle: z.number(),
  backColour: z.string(),
  bold: z.boolean(),
  borderStyle: z.number(),
  encoding: z.number(),
  fontname: z.string(),
  fontsize: z.number(),
  italic: z.boolean(),
  marginL: z.number(),
  marginR: z.number(),
  marginV: z.number(),
  name: z.string(),
  outline: z.number(),
  outlineColour: z.string(),
  activeOutlineColor: z.string(),
  primaryColour: z.string(),
  scaleX: z.number(),
  scaleY: z.number(),
  secondaryColour: z.string(),
  shadow: z.number(),
  spacing: z.number(),
  strikeOut: z.literal(0).or(z.literal(1)),
  underline: z.boolean(),
  uppercase: z.boolean(),
  activeColour: z.string(),
  blur: z.number().optional(),
  alpha: z.number().optional(),
});
